import { useParams } from "react-router";
import {
  ContentHeader,
  MainContentArea,
  Title,
  ValueOrFallback,
} from "melco-ui";
import {
  HeaderButtonArea,
  MelcoModelsUserSerialNumber,
} from "melco-shared-logic";
import { useGenericDrawer } from "melco-shared-logic";
import { useLicense } from "../../hooks/licenses/useLicense";
import { LicenseMoreActionButton } from "../../components/licenses/LicenseMoreActionButton";
import { useTranslation } from "react-i18next";

import { CancelLicenseDrawer } from "../../components/licenses/drawer/Cancel/CancelLicenseDrawer";

import { TransferLicenseDrawer } from "../../components/licenses/drawer/transfer/TransferLicenseDrawer";
import { useRolesContext } from "../../hooks/roles/useRolesContext";
import { DisplayLicenseDetails } from "../../components/licenses/DisplayLicenseDetails";
import { useEffect, useState } from "react";

//const { spacings } = DesignTokens;

export const LicenseDetails: React.FC = () => {
  /**
   *          "history_type": {
              "1": "Created",
              "2": "Registered",
              "3": "Assigned",
              "4": "Removed",
              "5": "Cancelled",
              "6": "Activated",
              "7": "Deactivated",
              "8": "Transferred",
              "9": "Updated",
              "10": "Level changed" // UPGRADED
            },
   */

  const { t } = useTranslation();
  const cancelLicenseDrawer = useGenericDrawer();
  const transferLicenseDrawer = useGenericDrawer();

  const { licenseId } = useParams<{ licenseId: string }>();

  const [license, setLicense] = useState<
    MelcoModelsUserSerialNumber | undefined
  >();
  const { data, refetch } = useLicense(licenseId);

  useEffect(() => {
    setLicense(data);
  }, [data]);

  const { roles } = useRolesContext();

  const { serial_number } = license || {};

  console.log(license);

  const onCloseDrawerCallBackFn = () => {
    refetch();
    //navigate(0)
  };

  return (
    <MainContentArea
      header={
        <ContentHeader
          title={
            <>
              <Title level={5}> {t("main_menu.licenses")}</Title>
              <ValueOrFallback
                value={serial_number}
                fallback={t("global.fallback.empty")}
              />
            </>
          }
          extra={
            <>
              {/**
                 * License Status
                 * 0-NotActivated
                   1-Activated
                   2-Cancelled
                 */}
              <HeaderButtonArea />
              {license &&
                license?.type !== 2 &&
                (roles.VIRTUAL_SECURITY_CANCEL ||
                  roles.VIRTUAL_SECURITY_TRANSFER) && (
                  <LicenseMoreActionButton
                    license={license}
                    cancelLicenseDrawer={cancelLicenseDrawer}
                    transferLicenseDrawer={transferLicenseDrawer}
                  />
                )}
            </>
          }
        />
      }
      contentPadding
    >
      <DisplayLicenseDetails
        license={license}
        onCloseDrawerCallBackFn={onCloseDrawerCallBackFn}
      />

      {license && (
        <>
          <TransferLicenseDrawer
            license={license}
            drawer={transferLicenseDrawer}
            onCloseDrawerCallBack={onCloseDrawerCallBackFn}
          />
        </>
      )}
      {license && (
        <>
          <CancelLicenseDrawer
            licenseSerialNumberToCancel={license?.serial_number ?? ""}
            licenseProductCode={license?.product_code ?? ""}
            drawer={cancelLicenseDrawer}
            onCloseDrawerCallBack={onCloseDrawerCallBackFn}
          />
        </>
      )}
    </MainContentArea>
  );
};
